
export default function formatTrimestre(trimestreLibelle) {
  let mois = '';
  switch (trimestreLibelle.substr(0, 1)) {
    case 'P':
      mois = 'Janvier - Mars';
      break;
    case 'D':
      mois = 'Avril - Juin';
      break;
    case 'T':
      mois = 'Juillet - Septembre';
      break;
    case 'Q':
      mois = 'Octobre - Décembre';
      break;
  }
  return `${trimestreLibelle} (${mois})`;
}